"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.rag.description': '配置RAG（检索增强生成）设置用于AI知识处理',
    'settings.rag.failedToLoad': 'RAG设置加载失败',
    'settings.rag.savedSuccessfully': 'RAG设置保存成功',
    'settings.rag.failedToSave': 'RAG设置保存失败',
    'settings.rag.save': '保存RAG设置',
    'settings.rag.indexing.title': '索引设置',
    'settings.rag.indexing.chunkSize': '块大小',
    'settings.rag.indexing.chunkSize.help': '每个文本块的最大字符数 (100-10000)',
    'settings.rag.indexing.chunkOverlap': '块重叠',
    'settings.rag.indexing.chunkOverlap.help': '相邻块之间重叠的字符数 (0-1000)',
    'settings.rag.indexing.separators': '文本分隔符',
    'settings.rag.indexing.separators.placeholder': '输入用逗号分隔的分隔符（如 .\\n\\n, \\n）',
    'settings.rag.indexing.separators.help': '用于将文本分割成块的字符或字符串。使用\\n表示换行，\\t表示制表符。用逗号分隔多个值。',
    'settings.rag.search.title': '搜索设置',
    'settings.rag.search.defaultMaxResults': '默认最大结果数',
    'settings.rag.search.defaultMaxResults.help': '搜索返回的默认结果数量 (1-50)',
    'settings.rag.search.maxResults': '最大结果数',
    'settings.rag.search.maxResults.help': '搜索允许的最大结果数量 (1-100)',
    'settings.rag.search.similarityThreshold': '相似度阈值',
    'settings.rag.search.similarityThreshold.help': '搜索结果的最小相似度分数 (0-1)',
};
